
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import NewsItem2 from "@/components/items/news/NewsItem2.vue";

@Component({
  components: {
    NewsItem2,
  },
  filters,
})
export default class News2 extends Vue {
  @Prop({ default: [] })
  private news!: Array<any>;
  @Prop({ default: "" })
  private title!: string;
}
